module.exports = __webpack_public_path__ + "img/NIU.15f79e6c.svg";